import { readonly, ref, watchEffect } from 'vue'

export function useUnreadMessages() {
  const unreadCount = ref(0)
  const originalTitle = typeof document !== 'undefined' ? document.title : 'DAO-MED'
  const isTabActive = ref(typeof document !== 'undefined' ? !document.hidden : true)

  const handleVisibilityChange = () => {
    if (typeof document === 'undefined') return

    isTabActive.value = !document.hidden
  }

  let isEventListenerAdded = false

  const initializeEventListeners = () => {
    if (typeof document === 'undefined' || isEventListenerAdded) return

    document.addEventListener('visibilitychange', handleVisibilityChange)
    isEventListenerAdded = true

    isTabActive.value = !document.hidden
  }

  if (typeof document !== 'undefined') {
    initializeEventListeners()
  }

  watchEffect(() => {
    if (typeof document === 'undefined') return

    const newTitle = unreadCount.value > 0
      ? `(${unreadCount.value}) ${originalTitle}`
      : originalTitle

    document.title = newTitle
  })

  const incrementUnread = () => {
    if (!isTabActive.value) {
      unreadCount.value++
    }
  }

  const resetUnread = () => {
    unreadCount.value = 0
  }

  const setUnreadCount = (count: number) => {
    unreadCount.value = count
  }

  const cleanup = () => {
    if (typeof document === 'undefined' || !isEventListenerAdded) return

    document.removeEventListener('visibilitychange', handleVisibilityChange)
    isEventListenerAdded = false

    document.title = originalTitle
  }

  return {
    unreadCount,
    incrementUnread,
    resetUnread,
    setUnreadCount,
    cleanup,
    isTabActive: readonly(isTabActive),
    initializeEventListeners,
  }
}
